window.slider = slider;

function slider (options) {
	let defaultOptions =  {
		itemPerRow: 4,
		loop : true,
		draggable : true,
		mouseWheel : false,
		autoplay : true,
		stopAutoplayWhenHover : true,
		nav : true,
		elementId : ''
	}
	options = {...defaultOptions, ...options};
	let container = document.getElementById(options.elementId);
	for (const [key, value] of Object.entries(options)) {
		if(container.dataset[key]){
			if(container.dataset[key] === 'true' || container.dataset[key] === 'false'){
				options[key] = (container.dataset[key] === "true");
			} else {
				options[key] = parseInt(container.dataset[key]);
			}
		}
	}
	let _this = this;
	//extract arguments
	container.carousel = container.querySelector('.own-carousel');
	container.carouselOuter = container.querySelector('.own-carousel__outer');
	container.index = 0;
	container.carouselItem = container.carousel.children;
	container.imgWidth = container.carouselItem[0].getBoundingClientRect().width;
	container.numberOfItem = container.carouselItem.length;
	container.itemPerRow = Math.floor(container.offsetWidth / container.imgWidth );
	container.step = container.imgWidth;
	container.loop = options.loop; //attach loop to the HTML Element
	if (container.loop) {
		//if loop is true, clone carousel item
		container.index = container.itemPerRow;
		container.carousel.style.transform = `translate3d(${
			-container.index * container.step
		}px,0,0)`;
		for (let i = 0; i < container.itemPerRow; i++) {
			let cloneNode = container.carouselItem[i].cloneNode(true);
			container.carousel.insertAdjacentElement("beforeend", cloneNode);
		}
		let count = 0;
		while (count !== container.itemPerRow) {
			let cloneNode = container.carouselItem[container.numberOfItem - 1].cloneNode(
				true
			);
			container.carousel.insertAdjacentElement("afterbegin", cloneNode);
			count++;
		}
	}
	if(container.numberOfItem > container.itemPerRow || container.loop){
		if (container.loop && options.nav) {
			container.querySelector(".control__prev").style.display = "block";
			container.querySelector(".control__next").style.display = "block";
		} else if(options.nav){
			container.querySelector(".control__next").style.display = "block";
		}
		container.carousel.style.justifyContent = "normal"
	}

	container.translateSlide = () => {
		container.carousel.style.transform = `translate3d(${
			-container.index * container.step
		}px,0,0)`;
		if (!container.loop && options.nav && container.numberOfItem > container.itemPerRow) {
			if(container.index + container.itemPerRow === container.numberOfItem ){
				container.querySelector(".control__prev").style.display = "block";
				container.querySelector(".control__next").style.display = "none";
			} else if(container.index === 0){
				container.querySelector(".control__prev").style.display = "none";
				container.querySelector(".control__next").style.display = "block";
			} else {
				container.querySelector(".control__prev").style.display = "block";
				container.querySelector(".control__next").style.display = "block";
			}
		}
		//just a function used many time, to translate slide
	};

	container.resetSlide = (step) => {
		//reset slide, to make it loop
		if (container.index + step < 1) container.index = container.numberOfItem + 1;
		if (container.index + step >= container.numberOfItem + container.itemPerRow)
			container.index = container.itemPerRow - 1;
		container.carousel.style.transition = "none";
		container.translateSlide();
		//reset it silently by changing transition to none
		//then move it, i had delay 20ms because if we change inline style transition too fast, it will not work properly
		setTimeout(() => {
			container.carousel.style.transition = "all 0.25s";
			container.index += step;
			container.translateSlide();
		}, 20);
	};

	container.moveSlide = (step) => {
		container.carousel.style.transition = "all 0.25s";
		//every time we move slide, add transition
		if (container.loop) {
			if (
				container.index + step < 1 ||
				container.index + step >= container.numberOfItem + container.itemPerRow
			) {
				container.resetSlide(step);
			} else {
				container.index += step;
				container.translateSlide();
			}
		} else {
			if (
				container.index + step < 0 ||
				container.index + step > container.numberOfItem - container.itemPerRow
			)
				return;
			else {
				container.index += step;
				container.translateSlide();
			}
		}
	};

	if (options.nav) {
		container.querySelector(".control__prev").addEventListener("click", () => {
			container.moveSlide(-1);
		});
		container.querySelector(".control__next").addEventListener("click", () => {
			container.moveSlide(1);
		});
	}

	if (options.draggable) {
		//if draggable is true, add draggable-support event, variables,...
		let firstPos = (currentPos = 0);

		let dragStartHandle = (e) => {
			container.carousel.style.transition = "none";
			if (e.type === "touchstart") {
				currentPos = e.touches[0].clientX;
				document.addEventListener("touchmove", dragHandle);
				document.addEventListener("touchend", dragEndHandle);
			} else {
				container.carouselOuter.style.cursor = "grab";
				currentPos = e.clientX;
				document.addEventListener("mousemove", dragHandle);
				document.addEventListener("mouseup", dragEndHandle);
			}
			firstPos = currentPos;
			//add necessary listener, style, reset first and current position
			if (options.autoplay > 0) {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
			}
		};

		let dragHandle = (e) => {
			let currentMove = parseFloat(
				container.carousel.style.transform.slice(12)
			); //get the x-axis of transform3d
			if(isNaN(currentMove)){currentMove = 0}
			let currentIndex = -currentMove / container.step;

			let x = e.type === "touchmove" ? e.touches[0].clientX : e.clientX; //get current coordinate
			let distanceMoved = x - currentPos;
			if (container.loop) {
				if (currentIndex <= 0) {
					container.index = container.numberOfItem;
					container.translateSlide();
				} else if (
					currentIndex >=
					container.numberOfItem + container.itemPerRow
				) {
					container.index = container.itemPerRow;
					container.translateSlide();
				} else
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved
					}px,0,0)`;
			} else {
				if (
					currentIndex < 0 ||
					currentIndex > container.numberOfItem - container.itemPerRow
				)
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved / 5
					}px,0,0)`;
				//when user drag out of bound, decrease speed
				else
					container.carousel.style.transform = `translate3d(${
						currentMove + distanceMoved
					}px,0,0)`;
			}
			currentPos = x;
		};

		container.checkIndex = (currentMove) => {
			let temp = currentMove;
			while (temp >= container.step) {
				temp -= container.step;
			}
			if (
				(temp > 50 && firstPos - currentPos >= 0) ||
				(container.step - temp < 50 && firstPos - currentPos <= 0)
			)
				return Math.ceil(currentMove / container.step);
			return Math.floor(currentMove / container.step);
		}; // this function is used to check current index to determine move next or previous

		let dragEndHandle = (e) => {
			if (e.type === "touchend") {
				document.removeEventListener("touchmove", dragHandle);
				document.removeEventListener("touchend", dragEndHandle);
			} else {
				document.removeEventListener("mousemove", dragHandle);
				document.removeEventListener("mouseup", dragEndHandle);
				container.carouselOuter.style.cursor = "auto";
			}
			//remove unnecessary event listener and style
			let currentMove = parseFloat(
				container.carousel.style.transform.slice(12)
			);
			container.index = container.checkIndex(-currentMove);
			if (!container.loop) {
				if (container.index > container.numberOfItem - container.itemPerRow)
					container.index = container.numberOfItem - container.itemPerRow;
				if (container.index < 0) container.index = 0;
			}
			container.carousel.style.transition = "all 0.25s";
			container.translateSlide();
			if (options.autoplay > 0) {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					intervalId = setInterval(container.moveSlide, options.autoplay, 1);
				}, 2000);
			}
		};

		container.carouselOuter.addEventListener("mousedown", dragStartHandle);
		container.carouselOuter.addEventListener("touchstart", dragStartHandle);
		// i had to create carouselOuter because carousel will be hidden when slide is working
	}

	if (options.mouseWheel) {
		container.carouselOuter.addEventListener("wheel", (e) => {
			e.preventDefault();
			if (e.deltaY > 0) container.moveSlide(-1);
			else container.moveSlide(1);
		});
	}

	let intervalId;
	let timeoutId;

	if (options.autoplay > 0) {
		timeoutId = setTimeout(() => {
			intervalId = setInterval(container.moveSlide, options.autoplay, 1);
		}, 3000);
		if (options.stopAutoplayWhenHover) {
			container.carouselOuter.addEventListener("mouseenter", () => {
				clearTimeout(timeoutId);
				clearInterval(intervalId);
			});
			container.carouselOuter.addEventListener("mouseleave", () => {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					intervalId = setInterval(container.moveSlide, options.autoplay, 1);
				}, 2000);
			});
		}
	}
}

function debounceSlider(fn, delay) {
	let id = null;
	return function (args) {
		clearTimeout(id);
		id = null;
		id = setTimeout(function () {
			fn.call(this, args);
		}, delay);
	};
}

function responsiveSlider() {
	let crsContainer = document.querySelectorAll(".own-carousel__container");
	let containerArray = Array.from(crsContainer);
	containerArray.forEach((item) => {
		if(!item.carouselItem){
			console.log(item);
			return false;
		}
		item.imgWidth = item.carouselItem[0].getBoundingClientRect().width;
		item.step = item.imgWidth;
		item.itemPerRow = Math.floor(item.offsetWidth / item.imgWidth);
		if(item.numberOfItem <= item.itemPerRow && !item.loop){
			item.querySelector(".control__prev").style.display = "none";
			item.querySelector(".control__next").style.display = "none";
			item.index = 0;
			item.carousel.style.transform = `translate3d(${
				-item.index * item.step
			}px,0,0)`;
			item.carousel.style.justifyContent = "center"
		} else {
			item.carousel.style.justifyContent = "normal"
			item.moveSlide(0);
		}

	});
}

window.addEventListener("resize", debounceSlider(responsiveSlider, 500));
//reduce the number of execution for performance

